import FormContact from '../components/FormContact'

export default function ContactPage() {
  return <FormContact />
}
